export default __webpack_public_path__ + "static/media/mode-20.363dc7c8.svg";